function BulletList({ items }) {
  return (
    <ul className="docu vs-extended__list">
      {items.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>
  )
}

function parseBulletLines(s) {
  return s
    .split('\n')
    .map((x) => x.trim())
    .filter(Boolean)
}

/**
 * Key difference, pricing, CTA, and “when to choose” ,  after comparison table.
 * @param {'landing' | 'blog'} variant
 */
export function DocuSignVsPrimeExtendedSections({ t, variant = 'landing', onStartFree }) {
  const isBlog = variant === 'blog'
  const pClass = isBlog ? undefined : 'docusign alt-landing__prose'
  const sec = isBlog ? undefined : 'docusign alt-landing__docu-section'
  const h2c = isBlog ? undefined : 'docusign alt-landing__section-h2'
  const h3c = isBlog ? undefined : 'docusign alt-landing__section-h3'

  const docuBullets = parseBulletLines(t('seoLanding.docuVs.whenDocuSignBullets'))
  const primeBullets = parseBulletLines(t('seoLanding.docuVs.whenPrimeBullets'))

  const P = ({ k }) => (pClass ? <p className={pClass}>{t(k)}</p> : <p>{t(k)}</p>)

  return (
    <>
      <section className={sec}>
        <h2 className={h2c}>{t('seoLanding.docuVs.keyDiffTitle')}</h2>
        <P k="seoLanding.docuVs.keyDiffP1" />
        <P k="seoLanding.docuVs.keyDiffP2" />
        <P k="seoLanding.docuVs.keyDiffP3" />
      </section>

      <section className={sec}>
        <h2 className={h2c}>{t('seoLanding.docuVs.pricingSectionTitle')}</h2>
        <P k="seoLanding.docuVs.pricingP1" />
        <P k="seoLanding.docuVs.pricingP2" />
        <P k="seoLanding.docuVs.pricingP3" />
      </section>

      <section className={sec}>
        <h2 className={h2c}>{t('seoLanding.docuVs.methodologyTitle')}</h2>
        <P k="seoLanding.docuVs.methodologyP1" />
        <P k="seoLanding.docuVs.methodologyP2" />
      </section>

      <section className="docu vs-extended__cta-band" aria label={t('seoLanding.docuVs.ctaBandAria')}>
        <p className="docu vs-extended__cta-title">{t('seoLanding.docuVs.ctaTitle')}</p>
        <p className="docu vs-extended__cta-text">{t('seoLanding.docuVs.ctaBody')}</p>
        {onStartFree ? (
          <button type="button" className="primary button docu vs-extended__cta-btn" onClick={onStartFree}>
            {t('seoLanding.docuVs.ctaButton')}
          </button>
        ) : (
          <a href="/" className="primary button docu vs-extended__cta-btn">
            {t('seoLanding.docuVs.ctaButton')}
          </a>
        )}
      </section>

      <section className={sec}>
        <h2 className={h2c}>{t('seoLanding.docuVs.whenTitle')}</h2>
        <h3 className={h3c}>{t('seoLanding.docuVs.whenDocuSignHeading')}</h3>
        <BulletList items={docuBullets} />
        <h3 className={h3c}>{t('seoLanding.docuVs.whenPrimeHeading')}</h3>
        <BulletList items={primeBullets} />
      </section>
    </>
  )
}
